module.exports = __webpack_public_path__ + "img/log2.5128f8c9.png";